import { Environment, type EnvironmentHostname } from '~/types/Environments'

const portalOrigins: Record<EnvironmentHostname, string> = {
  [Environment.production]: 'https://portal.gmpplus.org',
  [Environment.test]: 'https://portaltst.gmpplus.org',
  [Environment.development]: 'https://portaldev.gmpplus.org',
  [Environment.acceptance]: 'https://portaldev.gmpplus.org',
  [Environment.local]: 'https://portaldev.gmpplus.org',
}

const fellowmindPortalHostnames = new Set([
  'portal.gmpplus.org',
  'portaltst.gmpplus.org',
  'portaldev.gmpplus.org',
])

export const resolvePortalUrl = (url: string, environment: EnvironmentHostname) => {
  try {
    const resolvedUrl = new URL(url)

    if (!fellowmindPortalHostnames.has(resolvedUrl.hostname)) return url

    const portalOrigin = portalOrigins[environment] ?? portalOrigins[Environment.local]
    const { hostname, protocol } = new URL(portalOrigin)

    resolvedUrl.protocol = protocol
    resolvedUrl.hostname = hostname

    return resolvedUrl.toString()
  } catch {
    return url
  }
}
